/**
 * Swiper
 */

 var component_swiper_gallery = function() {

  // setup args
  const slider = document.querySelector('.gallery .swiper');

  // validate
  if (!slider) {
    console.log('no slider element suplied');
    return;
  }


  /**
   * Init
   */
  function init_component_swiper_gallery() {

    const swiper = new Swiper('.gallery .swiper', {

      // optional parameters
      direction: 'horizontal',
      watchOverflow: true,
      loop: false,
      // slidesPerView: "auto",
      allowTouchMove: false,
      slidesPerView: 3,
      spaceBetween: 24,
      breakpoints: {
        560: {
          slidesPerView: 4,
        },
        //
        1120: {
          slidesPerView: 6,
          spaceBetween: 48,
        },
      },

      // navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // pagination
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
        type: 'bullets',
      },

      // button screen reader text
      a11y: {
        prevSlideMessage: theme_strings.next,
        nextSlideMessage: theme_strings.prev,
      },
    });

    return;
  }
  init_component_swiper_gallery();

  // make the call chainable
  return this;
};
